"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTheme = void 0;
var react_1 = require("@chakra-ui/react");
var button_1 = __importDefault(require("./components/button"));
var heading_1 = __importDefault(require("./components/heading"));
var tabs_1 = __importDefault(require("./components/tabs"));
var text_1 = __importDefault(require("./components/text"));
var card_1 = __importDefault(require("./components/card"));
var checkbox_1 = __importDefault(require("./components/checkbox"));
var switch_1 = require("./components/switch");
var colors_1 = __importDefault(require("./colors"));
var styles_1 = __importDefault(require("./styles"));
var commonInputs_1 = __importDefault(require("./components/commonInputs"));
var createTheme = function (brandingColors, sdkTheme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30;
    var sdkColors = (sdkTheme === null || sdkTheme === void 0 ? void 0 : sdkTheme.version) === 1 ? sdkTheme.colors : undefined;
    var brandColors = {
        base: (_a = sdkColors === null || sdkColors === void 0 ? void 0 : sdkColors.primary) !== null && _a !== void 0 ? _a : (((_c = (_b = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _b === void 0 ? void 0 : _b['base-color']) === null || _c === void 0 ? void 0 : _c.value)
            ? "#".concat(brandingColors.core['base-color'].value)
            : ((_e = (_d = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _d === void 0 ? void 0 : _d['primary-color']) === null || _e === void 0 ? void 0 : _e.value)
                ? "#".concat(brandingColors.core['primary-color'].value)
                : (_f = colors_1.default.brand) === null || _f === void 0 ? void 0 : _f.base),
        text: (_g = sdkColors === null || sdkColors === void 0 ? void 0 : sdkColors.text) !== null && _g !== void 0 ? _g : (((_j = (_h = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _h === void 0 ? void 0 : _h['text-color']) === null || _j === void 0 ? void 0 : _j.value)
            ? "#".concat(brandingColors.core['text-color'].value)
            : (_k = colors_1.default.brand) === null || _k === void 0 ? void 0 : _k.text),
        accent1: (_l = sdkColors === null || sdkColors === void 0 ? void 0 : sdkColors.secondary) !== null && _l !== void 0 ? _l : (((_o = (_m = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _m === void 0 ? void 0 : _m['accent-color-1']) === null || _o === void 0 ? void 0 : _o.value)
            ? "#".concat(brandingColors.core['accent-color-1'].value)
            : ((_q = (_p = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _p === void 0 ? void 0 : _p['secondary-color']) === null || _q === void 0 ? void 0 : _q.value)
                ? "#".concat(brandingColors.core['secondary-color'].value)
                : (_r = colors_1.default.brand) === null || _r === void 0 ? void 0 : _r.accent1),
        accent2: (_s = sdkColors === null || sdkColors === void 0 ? void 0 : sdkColors.tertiary) !== null && _s !== void 0 ? _s : (((_u = (_t = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _t === void 0 ? void 0 : _t['accent-color-2']) === null || _u === void 0 ? void 0 : _u.value)
            ? "#".concat(brandingColors.core['accent-color-2'].value)
            : ((_w = (_v = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _v === void 0 ? void 0 : _v['tertiary-color']) === null || _w === void 0 ? void 0 : _w.value)
                ? "#".concat(brandingColors.core['tertiary-color'].value)
                : (_x = colors_1.default.brand) === null || _x === void 0 ? void 0 : _x.accent2),
        accent3: ((_z = (_y = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _y === void 0 ? void 0 : _y['accent-color-3']) === null || _z === void 0 ? void 0 : _z.value)
            ? "#".concat(brandingColors.core['accent-color-3'].value)
            : (_0 = colors_1.default.brand) === null || _0 === void 0 ? void 0 : _0.accent3,
        accent4: ((_2 = (_1 = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _1 === void 0 ? void 0 : _1['accent-color-4']) === null || _2 === void 0 ? void 0 : _2.value)
            ? "#".concat(brandingColors.core['accent-color-4'].value)
            : (_3 = colors_1.default.brand) === null || _3 === void 0 ? void 0 : _3.accent4,
        background: (_4 = sdkColors === null || sdkColors === void 0 ? void 0 : sdkColors.background) !== null && _4 !== void 0 ? _4 : (((_6 = (_5 = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _5 === void 0 ? void 0 : _5['background-color']) === null || _6 === void 0 ? void 0 : _6.value)
            ? "#".concat(brandingColors.core['background-color'].value)
            : (_7 = colors_1.default.brand) === null || _7 === void 0 ? void 0 : _7.background),
        header: (_8 = sdkColors === null || sdkColors === void 0 ? void 0 : sdkColors.header) !== null && _8 !== void 0 ? _8 : (((_10 = (_9 = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _9 === void 0 ? void 0 : _9['header-color']) === null || _10 === void 0 ? void 0 : _10.value)
            ? "#".concat(brandingColors.core['header-color'].value)
            : (_11 = colors_1.default.brand) === null || _11 === void 0 ? void 0 : _11.header),
        link: (_12 = sdkColors === null || sdkColors === void 0 ? void 0 : sdkColors.link) !== null && _12 !== void 0 ? _12 : (((_14 = (_13 = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _13 === void 0 ? void 0 : _13['link-color']) === null || _14 === void 0 ? void 0 : _14.value)
            ? "#".concat(brandingColors.core['link-color'].value)
            : (_15 = colors_1.default.brand) === null || _15 === void 0 ? void 0 : _15.link),
        primaryButton: (_17 = (_16 = sdkColors === null || sdkColors === void 0 ? void 0 : sdkColors.actions) === null || _16 === void 0 ? void 0 : _16.primary) !== null && _17 !== void 0 ? _17 : (((_19 = (_18 = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _18 === void 0 ? void 0 : _18['primary-button-color']) === null || _19 === void 0 ? void 0 : _19.value)
            ? "#".concat(brandingColors.core['primary-button-color'].value)
            : (_20 = colors_1.default.brand) === null || _20 === void 0 ? void 0 : _20.primaryButton),
        secondaryButton: (_22 = (_21 = sdkColors === null || sdkColors === void 0 ? void 0 : sdkColors.actions) === null || _21 === void 0 ? void 0 : _21.secondary) !== null && _22 !== void 0 ? _22 : (((_24 = (_23 = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _23 === void 0 ? void 0 : _23['secondary-button-color']) === null || _24 === void 0 ? void 0 : _24.value)
            ? "#".concat(brandingColors.core['secondary-button-color'].value)
            : (_25 = colors_1.default.brand) === null || _25 === void 0 ? void 0 : _25.secondaryButton),
        tertiaryButton: (_27 = (_26 = sdkColors === null || sdkColors === void 0 ? void 0 : sdkColors.actions) === null || _26 === void 0 ? void 0 : _26.tertiary) !== null && _27 !== void 0 ? _27 : (((_29 = (_28 = brandingColors === null || brandingColors === void 0 ? void 0 : brandingColors.core) === null || _28 === void 0 ? void 0 : _28['tertiary-button-color']) === null || _29 === void 0 ? void 0 : _29.value)
            ? "#".concat(brandingColors.core['tertiary-button-color'].value)
            : (_30 = colors_1.default.brand) === null || _30 === void 0 ? void 0 : _30.tertiaryButton),
    };
    return (0, react_1.extendTheme)({
        config: {
            initialColorMode: 'light',
            useSystemColorMode: false,
            // cssVarPrefix: '',
        },
        styles: styles_1.default,
        semanticTokens: {
            colors: {
                'chakra-body-text': {
                    _light: 'alphaBlack.900',
                    _dark: 'gray.100',
                },
                'chakra-body-bg': {
                    _light: 'white',
                    _dark: 'gray.900',
                },
                'chakra-border-color': {
                    _light: 'gray.200',
                    _dark: 'gray.700',
                },
            },
        },
        colors: __assign(__assign({}, colors_1.default), { brand: brandColors }),
        components: __assign(__assign({ Button: button_1.default, Switch: switch_1.switchTheme, Text: text_1.default }, commonInputs_1.default), { Radio: {
                variants: {
                    dark: {
                        _checked: {
                            borderColor: 'black.base',
                            bg: 'black.base',
                        },
                        control: {
                            _checked: {
                                borderColor: 'black.base',
                                bg: 'black.base',
                                _hover: {
                                    borderColor: 'black.base',
                                    bg: 'black.base',
                                },
                            },
                        },
                    },
                },
            }, Tabs: tabs_1.default, Card: card_1.default, Checkbox: checkbox_1.default, Heading: heading_1.default, Divider: {
                baseStyle: {
                    borderColor: 'silver.base',
                    opacity: 1,
                },
            }, FormLabel: {
                baseStyle: {
                    fontSize: '0.688rem',
                    mb: 1,
                    _invalid: {
                        color: 'red.base',
                    },
                    _disabled: {
                        opacity: 1,
                    },
                },
            }, Modal: {
                baseStyle: {
                    dialog: {
                        bg: 'white',
                        borderRadius: '2xl',
                    },
                },
            } }),
    });
};
exports.createTheme = createTheme;
